// Lenis smooth scroll, synced to GSAP's ticker so scrubbed ScrollTriggers track
// the smoothed position (guidelines §4). Skipped entirely for reduced motion.
import Lenis from 'lenis';
import { gsap, ScrollTrigger, prefersReduced } from '../gsap-init.js';

if (!prefersReduced) {
  const lenis = new Lenis({
    duration: 1.05,
    easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // expo-out
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.4,
  });

  // Critical: keep ScrollTrigger in step with the smoothed scroll value.
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);

  // Pause Lenis while the fullscreen nav overlay locks the body.
  const overlay = document.querySelector('[data-nav-overlay]');
  if (overlay) {
    new MutationObserver(() => {
      document.body.classList.contains('no-scroll') ? lenis.stop() : lenis.start();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  // Expose for debugging / other modules (e.g. anchor scrolls).
  window.ccLenis = lenis;
}
